/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useLazyQuery } from '@apollo/client';

export const POOLEDACCOUNTDETAIL_GQL = gql`
  query GetPooledAccount {
    checkPooledAccounts {
        hasPooledAccounts
    }
  
  }
`;

export const usePooledAccountDetails = (shouldSkip) => {

  const [getPooledAccountDetails, pooledAccountDetail] = useLazyQuery(POOLEDACCOUNTDETAIL_GQL, {
    skip: shouldSkip,
    context:{
      clientName:'securestorage'
    }
  });

  return { getPooledAccountDetails, pooledAccountDetail };
};